import { getCurrentLocationAndLanguage, getCountryInfo, LocationKey, LanguageKey } from '@utils/location';
import Flag from 'react-world-flags';
import { ThunderIcon } from '@components/icons/thunder-icon';
import React from 'react';
export const USFlag = () => <Flag code="US" width={20} height={15} data-sentry-element="Flag" data-sentry-component="USFlag" data-sentry-source-file="site-settings.tsx" />;
export const ENFlag = () => <Flag code="GB" width={20} height={15} data-sentry-element="Flag" data-sentry-component="ENFlag" data-sentry-source-file="site-settings.tsx" />;
export const TRFlag = () => <Flag code="TR" width={20} height={15} data-sentry-element="Flag" data-sentry-component="TRFlag" data-sentry-source-file="site-settings.tsx" />;
export const RUFlag = () => <Flag code="RU" width={20} height={15} data-sentry-element="Flag" data-sentry-component="RUFlag" data-sentry-source-file="site-settings.tsx" />;
export const AZFlag = () => <Flag code="AZ" width={20} height={15} data-sentry-element="Flag" data-sentry-component="AZFlag" data-sentry-source-file="site-settings.tsx" />;
export const KZFlag = () => <Flag code="KZ" width={20} height={15} data-sentry-element="Flag" data-sentry-component="KZFlag" data-sentry-source-file="site-settings.tsx" />;
export const IQFlag = () => <Flag code="IQ" width={20} height={15} data-sentry-element="Flag" data-sentry-component="IQFlag" data-sentry-source-file="site-settings.tsx" />;
export const GEFlag = () => <Flag code="GE" width={20} height={15} data-sentry-element="Flag" data-sentry-component="GEFlag" data-sentry-source-file="site-settings.tsx" />;
export const KGFlag = () => <Flag code="KG" width={20} height={15} data-sentry-element="Flag" data-sentry-component="KGFlag" data-sentry-source-file="site-settings.tsx" />;
export const UZFlag = () => <Flag code="UZ" width={20} height={15} data-sentry-element="Flag" data-sentry-component="UZFlag" data-sentry-source-file="site-settings.tsx" />;
const ALL_LANGUAGES: Record<LanguageKey, {
  name: string;
  icon: JSX.Element;
}> = {
  en: {
    name: 'EN',
    icon: <ENFlag />
  },
  tr: {
    name: 'TR',
    icon: <TRFlag />
  },
  ru: {
    name: 'RU',
    icon: <RUFlag />
  },
  az: {
    name: 'AZ',
    icon: <AZFlag />
  },
  kk: {
    name: 'KZ',
    icon: <KZFlag />
  },
  ka: {
    name: 'GE',
    icon: <GEFlag />
  },
  ky: {
    name: 'KG',
    icon: <KGFlag />
  },
  iq: {
    name: 'AR',
    icon: <IQFlag />
  },
  uz: {
    name: 'UZ',
    icon: <UZFlag />
  }
};
interface LocationAndLanguage {
  location: LocationKey;
  language: LanguageKey;
}
const {
  location,
  language
} = getCurrentLocationAndLanguage() as LocationAndLanguage;
const countryInfo = getCountryInfo(location);
const getMediaVideosLink = (location: LocationKey): string => {
  const links: Record<LocationKey, string> = {
    tr: 'https://www.youtube.com/AloeTurkey/videos',
    kz: 'https://www.youtube.com/@foreverlivingproductskazak9417/videos',
    kg: 'https://www.youtube.com/@flpkyrgyzstan6419/videos',
    az: 'https://vimeo.com/foreverglobalhq',
    ge: 'https://vimeo.com/foreverglobalhq',
    iq: 'https://vimeo.com/foreverglobalhq',
    uz: 'https://www.youtube.com/@FLPUzbekistan'
  };
  return links[location] || 'https://www.youtube.com';
};
export const siteSettings = {
  name: 'Forever Living Products',
  description: "Forever Living has the highest quality aloe vera products and is recognized as the world's leading multi-level marketing opportunity (FBO) for forty six years!",
  author: {
    name: 'Forever Living Products',
    websiteUrl: countryInfo?.additionalLink,
    address: ''
  },
  logo: {
    url: '/assets/images/logo.svg',
    alt: 'Forever Living Products',
    href: '/',
    width: 450,
    height: 100
  },
  defaultLanguage: language || 'en',
  currency: '',
  site_header: {
    menu: [{
      id: 1,
      path: '/',
      label: 'menu-forever',
      subMenu: [{
        id: 0,
        path: '/forever/about-us',
        label: 'menu-forever-about'
      }, {
        id: 1,
        path: '/forever/why-forever',
        label: 'menu-forever-why-forever'
      }, {
        id: 2,
        path: '/forever/events',
        label: 'menu-forever-events'
      }, {
        id: 3,
        path: '/forever/incentives',
        label: 'menu-forever-incentives'
      }, {
        id: 4,
        path: '/forever/faq',
        label: 'menu-forever-faq'
      }, {
        id: 5,
        path: '/forever/contact-us',
        label: 'menu-forever-contact'
      }]
    }, {
      id: 2,
      path: '/e-shop',
      label: 'menu-shop'
    }, {
      id: 3,
      path: '/',
      label: 'menu-promotions',
      hiddenFor: ['ge', 'iq', 'az', 'tr'],
      subMenu: [{
        id: 1,
        path: '/promotions/promo-events',
        label: 'menu-promo-events'
      }]
    }, {
      id: 4,
      path: '/',
      label: 'menu-products',
      subMenu: [...(location === 'tr' ? [{
        id: 3,
        path: 'https://flptr.com/catalog/tr/tr/mobile/index.html',
        label: 'menu-products-catalog',
        target: '_blank',
        rel: 'noopener noreferrer'
      }] : []), {
        id: 1,
        path: '/products/catalogue',
        label: 'menu-products-catalog',
        hiddenFor: ['tr']
      }, {
        id: 2,
        path: '/price-list',
        label: 'menu-products-price-list'
      }]
    }, {
      id: 5,
      path: '/',
      label: 'menu-media',
      subMenu: [...(location === 'tr' ? [{
        id: 1,
        path: '/products/catalogue',
        label: 'menu-catalogs'
      }] : []), {
        id: 2,
        path: '/multimedia/magazines',
        label: 'menu-media-magazines'
      }, {
        id: 3,
        path: '/multimedia/downloads',
        label: 'menu-media-downloads'
      }, {
        id: 4,
        path: getMediaVideosLink(location),
        label: 'menu-media-videos',
        target: '_blank',
        rel: 'noopener noreferrer'
      }]
    }, {
      id: 6,
      path: '/',
      label: 'menu-join',
      subMenu: [{
        id: 1,
        path: '/register/forever-business-owner',
        label: 'menu-forever-business-owner'
      }, {
        id: 2,
        path: '/register/forever-business-owner-ownform',
        label: 'menu-forever-business-owner-ownform',
        hiddenFor: ['uz', 'ge', 'iq', 'kz', 'kg']
      }, {
        id: 3,
        path: '/register/foreign-fbo',
        label: 'menu-foreign-fbo'
      }, {
        id: 4,
        path: '/register/active-entrepreneur',
        label: 'menu-active-entrepreneur',
        hiddenFor: ['ge', 'iq', 'uz', 'tr', 'az', 'kz', 'kg']
      }],
      unauthorized: true
    }],
    mobileMenu: [{
      id: 1,
      path: '/',
      label: 'menu-forever',
      subMenu: [{
        id: 0,
        path: '/forever/about-us',
        label: 'menu-forever-about'
      }, {
        id: 1,
        path: '/forever/why-forever',
        label: 'menu-forever-why-forever'
      }, {
        id: 2,
        path: '/forever/events',
        label: 'menu-forever-events'
      }, {
        id: 3,
        path: '/forever/incentives',
        label: 'menu-forever-incentives'
      }, {
        id: 4,
        path: '/forever/faq',
        label: 'menu-forever-faq'
      }, {
        id: 5,
        path: '/forever/contact-us',
        label: 'menu-forever-contact'
      }]
    }, {
      id: 2,
      path: '/e-shop',
      label: 'menu-shop'
    }, {
      id: 3,
      path: '/',
      label: 'menu-promotions',
      hiddenFor: ['ge', 'iq', 'az', 'tr'],
      subMenu: [{
        id: 1,
        path: '/promotions/promo-events',
        label: 'menu-promo-events'
      }]
    }, {
      id: 4,
      path: '/',
      label: 'menu-products',
      subMenu: [...(location === 'tr' ? [{
        id: 3,
        path: 'https://flptr.com/catalog/tr/tr/mobile/index.html',
        label: 'menu-products-catalog',
        target: '_blank',
        rel: 'noopener noreferrer'
      }] : []), {
        id: 1,
        path: '/products/catalogue',
        label: 'menu-products-catalog',
        hiddenFor: ['tr']
      }, {
        id: 2,
        path: '/price-list',
        label: 'menu-products-price-list'
      }]
    }, {
      id: 5,
      path: '/',
      label: 'menu-media',
      subMenu: [...(location === 'tr' ? [{
        id: 1,
        path: '/products/catalogue',
        label: 'menu-catalogs'
      }] : []), {
        id: 2,
        path: '/multimedia/magazines',
        label: 'menu-media-magazines'
      }, {
        id: 3,
        path: '/multimedia/downloads',
        label: 'menu-media-downloads'
      }, {
        id: 4,
        path: getMediaVideosLink(location),
        label: 'menu-media-videos',
        target: '_blank',
        rel: 'noopener noreferrer'
      }]
    }, {
      id: 6,
      path: '/',
      label: 'menu-join',
      subMenu: [{
        id: 1,
        path: '/register/forever-business-owner',
        label: 'menu-forever-business-owner'
      }, {
        id: 2,
        path: '/register/forever-business-owner-ownform',
        label: 'menu-forever-business-owner-ownform',
        hiddenFor: ['uz', 'ge', 'iq', 'kz', 'kg']
      }, {
        id: 3,
        path: '/register/foreign-fbo',
        label: 'menu-foreign-fbo'
      }, {
        id: 4,
        path: '/register/active-entrepreneur',
        label: 'menu-active-entrepreneur',
        hiddenFor: ['ge', 'iq', 'uz', 'tr', 'az', 'kz', 'kg']
      }],
      unauthorized: true
    }],
    defaultLanguage: language || 'en',
    languageMenu: (() => {
      const {
        location
      } = getCurrentLocationAndLanguage();
      const countryInfo = getCountryInfo(location);
      return countryInfo ? countryInfo.languages.map(lang => ({
        id: lang.val,
        name: ALL_LANGUAGES[lang.val as LanguageKey].name,
        value: lang.val,
        icon: ALL_LANGUAGES[lang.val as LanguageKey].icon
      })) : [];
    })(),
    pagesMenu: [{
      id: 1,
      path: '/search',
      label: 'menu-deals-today',
      icon: <ThunderIcon className='w-3 h-auto' />
    }, {
      id: 2,
      path: '/',
      label: 'menu-offers'
    }, {
      id: 3,
      path: '/forever/faq',
      label: 'menu-faq'
    }, {
      id: 4,
      path: '/forever/contact-us',
      label: 'menu-contact'
    }]
  }
};